import { GetStaticPaths } from 'next';
import PackageNextPage, { getStaticProps } from '..';

export { getStaticProps };

export const getStaticPaths: GetStaticPaths = () => ({
  fallback: 'blocking',
  paths: [],
});

export default PackageNextPage;
